<template>
    <section>
		<b-field>
				<b-autocomplete
                    ref="bauto"
					v-model="inputVal"
					icon="search"
					icon-pack="fa"
					:data="datasource"
					:placeholder="placeholder"
					:field="datafield"
					@typing="ontyping"
					:keep-first="keepFirst"
					expanded
					@select="option => selectWrapper(option)"
                    @keydown.native.enter="onenter">
					<template v-if="shownoresultstext" slot="empty">
						{{noresultstext}}
					</template>
				</b-autocomplete>
     
       <p class="control">
					<button class="button is-info is-hidden-tablet " v-on:click="submit">
            <i class="fa fa-search"></i>
          </button>
				</p>
				<p class="control">
					<button class="button is-hidden-tablet " v-on:click="clear">
            <strong>X</strong></button>
				</p>
				<p class="control">
					<button class="button is-info is-hidden-mobile " v-on:click="submit">{{searchtext}}</button>
				</p>
				<p class="control">
					<button class="button is-hidden-mobile " v-on:click="clear" >{{cleartext}}</button>
				</p>
		</b-field>
    </section>
</template>
<script type="text/javascript">
export default {
		name: "rxeob-autocomplete",
		props: {
			value: {
				type: [String,Number],
				default: null
			},
			ontyping: {
				type: Function,
				default: function(){
				}
			},
			datasource: {
				type: [Array],
				default: function() {
					return [];
				}
			},
			placeholder: {
				type: String,
				default: "Search"
            },
            searchtext: {
                type: String,
                default: "Search"
            },
            cleartext: {
                type: String,
                default: "Clear"
            },
            noresultstext: {
                type: String,
                default: "No results found"
            },
            shownoresultstext: {
                type: Boolean,
                default: true
            },
			datafield: {
				type: String,
				default: 'value'
			},
			onselect: {
				type: Function,
				default: function() {
					console.log("implement onselect for component");
				}
			},
			keepfirst: {
				type: Boolean,
				default: false
			},
			onsubmit: {
				type: Function,
				default: function() {
                    this.$refs.bauto.enterPressed();
				}
            },
            onenter: {
                type: Function,
                default: function () {
                    console.log("Implement on enter for component");
                }
            },
            clearcallback: {
                type: Function,
                default: function(){
                }
            }
		},
        data() {
            return {
				inputVal: this.value,
                data: [],
                selected: null,
                isFetching: false,
				keepFirst: this.keepfirst
            }
        },
		watch: {
			inputVal(val) {
			  this.$emit('input', val);
			}
		},
        methods: {
			selectWrapper: function(option){
				this.onselect(option);
			},
			clear: function(){
				this.inputVal = "";
                this.clearcallback();
			},
			submit: function(){
				this.onsubmit();
			}
        }
}
</script>



// WEBPACK FOOTER //
// RxeobAutocomplete.vue?143e609c